/**
 * Meta Pixel + Conversions API bridge.
 * Every business event fires once in the browser and once server-side with the SAME
 * event_id, so Meta deduplicates them. Revenue (Purchase/Subscribe) is server-only.
 */
import { api } from "@/lib/api";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let loaded = false;

export function loadPixel() {
  if (loaded || !PIXEL_ID || typeof window === "undefined") return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("consent", "grant");
  loaded = true;
}

const cookie = (name) =>
  document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=").slice(1).join("=") || null;

export function metaContext(eventId) {
  const fbclid = new URLSearchParams(window.location.search).get("fbclid");
  let fbc = cookie("_fbc");
  if (!fbc && fbclid) {
    fbc = `fb.1.${Date.now()}.${fbclid}`;
    document.cookie = `_fbc=${encodeURIComponent(fbc)}; Max-Age=7776000; Path=/; SameSite=Lax`;
  }
  return {
    fbp: cookie("_fbp"),
    fbc,
    event_source_url: window.location.href,
    client_user_agent: navigator.userAgent,
    event_id: eventId || null,
  };
}

const newId = (name) =>
  `${name.toLowerCase()}_${(crypto.randomUUID?.() || String(Math.random()).slice(2))}`;

/**
 * @param name  standard or Propojo custom event name
 * @param custom_data  Meta parameters (value, currency, content_ids…)
 * @param opts.eventId  pass a stable id to keep browser+server in one action
 * @param opts.email  used for hashed advanced matching (never sent raw to Meta)
 * @param opts.serverOnly / opts.browserOnly
 */
export function track(name, custom_data = {}, opts = {}) {
  const eventId = opts.eventId || newId(name);
  const standard = STANDARD.has(name);

  if (!opts.serverOnly && window.fbq) {
    window.fbq(standard ? "track" : "trackCustom", name, custom_data, { eventID: eventId });
  }
  if (!opts.browserOnly) {
    api
      .post("/marketing/track", {
        event_name: name,
        event_id: eventId,
        context: metaContext(eventId),
        email: opts.email || null,
        external_id: opts.externalId || null,
        custom_data,
      })
      .catch(() => {});
  }
  return eventId;
}

const STANDARD = new Set([
  "PageView", "ViewContent", "Lead", "CompleteRegistration", "StartTrial",
  "InitiateCheckout", "AddPaymentInfo", "Contact", "Search", "Subscribe", "Purchase",
]);
